import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDetailComponent } from './user-detail.component';
import { CoreModule } from 'app/core/core.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { RoleListModule } from '@components/role-list/role-list.module';
import { ChangePasswordModule } from '../change-password/change-password.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    CompanyListModule,
    RoleListModule,
    ChangePasswordModule,
  ],
  declarations: [UserDetailComponent],
  entryComponents: [UserDetailComponent],
})
export class UserDetailModule { }
